import dynamic from 'next/dynamic';
import { RoomOverviewProps } from './RoomOverview.types';

export const RoomOverviewMGP = dynamic<RoomOverviewProps>(() =>
  import('./RoomOverview').then(module => module.RoomOverview)
);
